export default __webpack_public_path__ + "static/media/contact.3036cb1d.svg";